export default "__VITE_ASSET__CfpvjyZ7__"